import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AreaBlockerModule,
  KalturaUIModule,
  StickyModule,
  TooltipModule,
  PopupWidgetModule,
  TagsModule,
} from '@kaltura-ng/kaltura-ui';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizationModule, FiltersModule } from '@kaltura-ng/mc-shared';
import { AutoCompleteModule, KalturaPrimeNgUIModule } from '@kaltura-ng/kaltura-primeng-ui';

import { CategoryTooltipPipe } from 'app-shared/content-shared/categories/category-tooltip.pipe';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { InputTextModule } from 'primeng/inputtext';
import { CategorySelectorComponent } from './category-selector/category-selector.component';
import { CategoriesFilterComponent } from './categories-filter/categories-filter.component';
import { CategoriesFilterPrefsComponent } from './categories-filter-preferences/categories-filter-preferences.component';
import { CategoriesTreeComponent } from './categories-tree/categories-tree.component';
import { CategoriesSearchService } from './categories-search.service';
import { CategoriesTreePropagationDirective } from './categories-tree/categories-tree-propagation.directive';

@NgModule({
  imports: [
    AreaBlockerModule,
    TooltipModule,
    AutoCompleteModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TreeModule,
    LocalizationModule,
    KalturaPrimeNgUIModule,
    KalturaUIModule,
    ButtonModule,
    CalendarModule,
    RadioButtonModule,
    CheckboxModule,
    PopupWidgetModule,
    MenuModule,
    TagsModule,
    PaginatorModule,
    TieredMenuModule,
    InputTextModule,
    StickyModule,
    FiltersModule,
  ],
  declarations: [
    CategorySelectorComponent,
    CategoriesTreeComponent,
    CategoriesFilterPrefsComponent,
    CategoriesFilterComponent,
    CategoryTooltipPipe,
    CategoriesTreePropagationDirective,
  ],
  exports: [
    CategorySelectorComponent,
    CategoriesTreeComponent,
    CategoriesFilterPrefsComponent,
    CategoriesFilterComponent,
    CategoryTooltipPipe,
  ],
})
export class CategoriesModule {
  static forRoot(): ModuleWithProviders<CategoriesModule> {
    return {
      ngModule: CategoriesModule,
      providers: [
        CategoriesSearchService, // singleton by design: this service sync inner state when needed thus can be shareable/provided by the module
      ],
    };
  }
}
